import { Autocomplete, Stack, styled, TextField } from "@mui/material";

const AutoComplete = styled(Autocomplete)(() => ({ width: 300, marginBottom: "16px" }));

const AutoCompleteWrapper = styled(Stack)(({ theme }) => ({
  "& .MuiAutocomplete-root": {
    margin: "8px auto 0px auto",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      margin: "0px"
    }
  },
  width: "100%",
  maxWidth: "280px",
  display: "flex",
  //   "& .MuiAutocomplete-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline ": {
  //     border: `1px solid ${theme.status.bordercolor}`
  //   },
  "& .MuiAutocomplete-root .MuiInputBase-root .MuiInputBase-input::placeholder": {
    color: theme.status.textgray6,
    opacity: 1
  },
  "& .MuiAutocomplete-root .MuiInputBase-root": {
    height: "48px"
  },
  "& .MuiAutocomplete-root .MuiInputBase-root .MuiInputBase-input": {
    fontSize: "14px"
  },
  "& .MuiAutocomplete-root .MuiAutocomplete-popper": {
    fontSize: "8px" // Change the font size as desired
  },
  "& .autocomplete-option-text": {
    fontSize: "14px !important"
  },
  [theme.breakpoints.down("sm")]: {
    "& .MuiAutocomplete-root": {
      maxWidth: "280px"
    },
    "& .MuiAutocomplete-root .MuiInputBase-root .MuiInputBase-input": {
      fontSize: "10px"
    },
    "& .MuiAutocomplete-root .MuiInputBase-root": {
      height: "32px"
    },
    "& .autocomplete-option-text": {
      fontSize: "10px !important"
    },
    maxWidth: "200px"
  }
}));

export default function AutocompleteDropdown(props) {
  const { options, handleChange, value, isDefaultOptions, label } = props;
  return (
    <AutoCompleteWrapper>
      <AutoComplete
        options={options}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" fullWidth label={label} placeholder="Select" />
        )}
        ListboxProps={{
          sx: {
            //   height: { xs: "120px", sm: "auto" },
            "& .MuiAutocomplete-option": {
              padding: "10px",
              minHeight: "0px"
            },
            fontSize: { xs: "12px", md: "14px" }
          }
        }}
        defaultValue={isDefaultOptions ? options?.[1] : ""}
        onChange={handleChange}
        value={value}
      />
    </AutoCompleteWrapper>
  );
}
